export type CommunitySettings = {
  newsfeed: boolean;
  messages: boolean;
  surveys: boolean;
  documents: boolean;
  events: boolean;
  facilities: boolean;
  appointments: boolean;
  marketplace: boolean;
  accounts: boolean;
  products: boolean;
  occupancySurvey: boolean;
  compliance: boolean;
  packages: boolean;
  keys: boolean;
  forms: boolean;
  safetyCenter: boolean;
};

export type CommunitySetting = keyof CommunitySettings;

export const mergeSettings = (
  settings: CommunitySettings[],
): CommunitySettings => {
  const mergedSettings: CommunitySettings = {
    newsfeed: false,
    messages: false,
    surveys: false,
    documents: false,
    events: false,
    facilities: false,
    appointments: false,
    marketplace: false,
    accounts: false,
    products: false,
    occupancySurvey: false,
    compliance: false,
    packages: false,
    keys: false,
    forms: false,
    safetyCenter: false,
  };

  for (const setting of settings) {
    for (const [key, value] of Object.entries(setting) as [
      keyof typeof setting,
      boolean,
    ][]) {
      mergedSettings[key] = mergedSettings[key] || value;
    }
  }

  return mergedSettings;
};
